import { AuxSelect } from "@blk/aladdin-react-components-es";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { language } from "language/default";
import { gridCurrencySelector, gridInitialOptionPlaceholderSelector, setCurrency } from "store/grids";
export const InsGridCurrencySelector = (props) => {
    const currency = useSelector((s) => gridCurrencySelector(s, props.stateId)), hideInitialPlaceholder = useSelector((s) => gridInitialOptionPlaceholderSelector(s, props.stateId));
    const values = props.currencies?.map((c) => ({ displayValue: c, isSelected: currency === c, value: c }));
    // If currency is provided in State but nothing is selected, select it by default
    if (!values?.some((x) => x.isSelected) && currency) {
        values?.push({ displayValue: currency, isSelected: true, value: currency });
    }
    const dispatch = useDispatch();
    if (!values?.length && !currency) {
        return React.createElement(React.Fragment, null);
    }
    return React.createElement(AuxSelect, { label: language.en.dashboard.currency, data: values?.length ? [{ values }] : [{ values: [{ displayValue: currency, isSelected: true, value: currency }] }], isLeftLabel: true, size: props.small ? "small" : "regular", hasInitialOptionPlaceholder: !hideInitialPlaceholder, onSelectionChanged: (e) => dispatch(setCurrency({ currency: e.detail.value ? e.detail.value.value : "", id: props.stateId })) });
};
